import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CheckItem } from './CheckItem';
type VolumeCardProps = {
  label: string;
  title: string;
  subtitle: string;
  points: string[];
  list?: string[];
  afterPoints?: string[];
  tagline?: string;
  finalLine: string;
  meta: string;
};
export function VolumeCard({
  label,
  title,
  subtitle,
  points,
  list,
  afterPoints,
  tagline,
  finalLine,
  meta
}: VolumeCardProps) {
  return <article className="overflow-hidden rounded-md border border-slate-200 bg-white" data-id="element-217" data-mp="1us39ycr7m5eg">
      <div className="flex items-center gap-2 bg-blue-950 px-3 py-2" data-id="element-218" data-mp="1pvcspm3o53rg">
        <span className="flex h-4 w-4 shrink-0 items-center justify-center rounded-[3px] bg-green-600" aria-hidden data-id="element-219" data-mp="1l3cupz75skxi">
          <CheckIcon className="h-3 w-3 text-white" strokeWidth={4} data-id="element-220" data-mp="1h2t0p4hvtxfl" />
        </span>
        <h3 className="text-[13px] font-extrabold uppercase leading-tight text-white md:text-[15px]" data-id="element-221" data-mp="2dkfixicdc4xk">
          {label} — {title}
        </h3>
      </div>
      <div className="px-3 py-2.5 md:px-4 md:py-3" data-id="element-222" data-mp="28rw6wptbxhuv">
        <p className="text-[13px] font-bold leading-snug text-teal-700 md:text-[14px]" data-id="element-223" data-mp="37bquh1j7o0ll">{subtitle}</p>
        <div className="mt-1.5 space-y-1 text-[14px] leading-[1.4] text-slate-600 md:text-[15px]" data-id="element-224" data-mp="3cbd6x8r7tctc">
          {points.map(p => <p key={p} data-id="element-225" data-mp="2xlo1v2g04ons">{p}</p>)}
        </div>
        {list && <ul className="mt-1.5 grid gap-x-4 gap-y-0.5 text-[14px] leading-[1.4] text-slate-600 sm:grid-cols-2 md:text-[15px]" data-id="element-226" data-mp="32k8tidh6u00m">
            {list.map(item => <CheckItem key={item} data-id="element-227" data-mp="2tklz4bmvluh2">{item}</CheckItem>)}
          </ul>}
        {afterPoints && <div className="mt-2 space-y-1 text-[14px] leading-[1.4] text-slate-600 md:text-[15px]" data-id="element-228" data-mp="2env40ek8j4x9">
            {afterPoints.map(p => <p key={p} data-id="element-229" data-mp="2jmofk1fyolus">{p}</p>)}
          </div>}
        {tagline && <p className="mt-2 text-[12px] font-extrabold uppercase leading-tight text-amber-700 md:text-[13px]" data-id="element-230" data-mp="cwhvzgmz0gwz">{tagline}</p>}
        <p className="mt-2 text-[12px] font-extrabold uppercase leading-tight text-teal-700 md:text-[13px]" data-id="element-231" data-mp="hsp2pbn6xwfz">
          {finalLine}
        </p>
        <p className="mt-1 text-[12px] font-semibold text-slate-500 md:text-[13px]" data-id="element-232" data-mp="bdrochkgpbj3">{meta}</p>
      </div>
    </article>;
}